import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { App } from "./App.js";
import { HomePage } from "./pages/HomePage.js";
import { LobbyPage } from "./pages/LobbyPage.js";
import { GamePage } from "./pages/GamePage.js";
import { JoinByCodePage } from "./pages/JoinByCodePage.js";
import { AdminPage } from "./pages/AdminPage.js";
import "./styles/global.css";

const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route element={<App />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/join/:code" element={<JoinByCodePage />} />
          <Route path="/lobby/:id" element={<LobbyPage />} />
          <Route path="/game/:id" element={<GamePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
